import { render, staticRenderFns } from "./skuPage.vue?vue&type=template&id=49475138&"
import script from "./skuPage.vue?vue&type=script&lang=js&"
export * from "./skuPage.vue?vue&type=script&lang=js&"
import style0 from "./skuPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports